import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.readable)?_c(VChipGroup,{attrs:{"active-class":"primary--text","column":""}},_vm._l((_vm.readable),function(tag){return _c(VChip,{key:tag,staticClass:"caption chip",attrs:{"disabled":"","active":"","small":""}},[_vm._v(_vm._s(tag))])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }